import { AnyAction, Reducer } from 'redux'

/**
 * reducer切片函数, 消除switch case样板代码
 *
 * @template S
 * @template A
 * @template Actions
 * @param {S} initialState  初始状态
 * @param {{ [key: string]: ReduxReducer<S, A> }} handlers  $ObjMap<T, F>
 * @returns {ReduxReducer<S, A>}
 * @example
 *
 * const initialState = {
 *   data,
 * }
 * function getData(state, action) {
 *   return {
 *     ...state,
 *     data: action.response.data,
 *   }
 * }
 *
 * function postData(state, action) {
 *   return {
 *     ...state,
 *     data: action.response.data,
 *   }
 * }
 *
 * export default createReducer(initialState, {
 *   GETDATA: getData,
 *   POSTDATA: postData,
 * })
 */
function createReducer<S, A extends AnyAction>(
  initialState: S,
  handlers: { [P in A['type']]: A extends { type: P } ? Reducer<S, A> : never },
): Reducer<S, A> {
  return (state: S = initialState, action: A): S =>
    (Object.prototype.hasOwnProperty.call(handlers, action.type) ?
      handlers[action.type](state, action) :
      state)
}

export default createReducer
